// src/utils/keysDelete.js
// Staff-side helper to delete R2 objects BY KEY (for storage that isn't a file_exchange row — today
// feedback attachments). Routes through /api/keys-delete (staff-gated, deletes+verifies+audits each key).
// Returns { error, deleted, failed } — error is null on a completed request (per-key outcomes in the arrays).
import { supabase } from '../supabase';

export async function keysDelete(keys) {
  try {
    if (!Array.isArray(keys) || keys.length === 0) return { error: null, deleted: [], failed: [] };
    const { data: { session } } = await supabase.auth.getSession();
    const token = session && session.access_token;
    if (!token) return { error: new Error('keysDelete: not signed in') };

    const resp = await fetch('/api/keys-delete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ keys }),
    });
    if (!resp.ok) {
      let reason = String(resp.status);
      try { const j = await resp.json(); reason = j.error || reason; } catch { /* non-json */ }
      return { error: new Error(`keysDelete: ${reason}`) };
    }
    const out = await resp.json();
    return { error: null, deleted: out.deleted || [], failed: out.failed || [] };
  } catch (e) {
    return { error: e };
  }
}
